const BASE_URL = 'https://ricgop.online/api';
export default BASE_URL;
